<template>
    <div class="emb-contact-wrap">
        <div class="section-gap primary pb-5">
            <v-container grid-list-xl py-0>
                <v-layout row wrap align-center justify-center text-center text-sm-center text-xl-left text-lg-left>
                    <v-flex xs12 sm12 md6 lg6 xl6>
                        <div class="subscribe-content">
                            <h1 class="translate-top white--text">
                                ¡Contáctanos, estaremos contentos de ayudarte!
                            </h1>
                            <p class="translate-right white--text">
                                Usa la tecnología para alcanzar los objetivos de tu negocio ¡No busques más!
                            </p> 
                            <v-btn color="success" rounded href="https://wa.me/51958805900" target="_new">Escribir al WhatsApp</v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6 xl6>
                        <div class="subscribe-content">
                            <div class="emb-aside-banner-v1 text-right">
                                <img class="emb-card" alt="aside-banner" src="/static/images/functionalities.jpg" width="547" height="315" />
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <div class="emb-contact-content">
            
            <div class="contact-info-wrapper">
                <v-container grid-list-xl py-0>
                    
                    <div class="section-gap">
                        <v-layout row wrap>
                            <v-flex sm12 md12 lg5 xl5>
                                <div class="sec-title">
                                    <h2 class="v-layout justify-start align-center">Información de contacto</h2>
                                    <h5 class="font-italic mb-6">
                                        Si tiene algún problema, sugerencias o comentarios, por favor no dude en contactar con nosotros. Elija
                                        nuestras formas de comunicación. Nos encantará saber de ti.
                                    </h5>
                                </div>
                                <!-- {{contactInfo.info}} -->
                                <div class="mb-6">
                                    <h3>Llamar</h3>
                                    <a href="tel:51958805900" class="color-inherit"> (064) 584616 </a>
                                </div>
                                <div class="mb-6">
                                    <h3>Correo</h3>
                                    <a href="mailto:ventas@sislii.com" class="color-inherit">ventas@sislii.com</a>
                                </div>
                                <!-- <div class="mb-6">
                                    <h3>Address</h3>
                                    <p>{{ contactInfo.address }}</p>
                                </div> -->
                            </v-flex>
                            <v-flex sm12 md12 lg7 xl7>
                                <div class="sec-title">
                                    <h2>Escríbenos</h2>
                                </div>
                                <v-form ref="form" v-model="valid">
                                    <v-text-field type="text" outlined dense placeholder="Nombre" :rules="inputRules.basictextRules"></v-text-field>
                                    <v-text-field
                                        type="text"
                                        outlined
                                        dense
                                        placeholder="Correo o Teléfono"
                                        :rules="inputRules.basictextRules"
                                    ></v-text-field>
                                    <v-textarea rows="3" outlined label="Deje su mensaje"></v-textarea>
                                    <v-btn rounded block class="accent mx-0 mt-4" large @click.stop.prevent="saveDetails">Enviar</v-btn>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-container>
            </div>
        </div>
    </div>
</template>

<script>
import api from 'Api';

export default {
    data() {
        return {
            valid: false,
            contactInfo: '',
            emailRules: [(v) => !!v || 'E-mail is required', (v) => /.+@.+/.test(v) || 'E-mail must be valid'],
            inputRules: {
                basictextRules: [(v) => !!v || 'Requerido'],
            },
        };
    },
    mounted() {
        // this.getContactInfo();
    },
    beforeCreate() {
		document.title = "Contacto | Sislii";
    },
    methods: {
        getContactInfo() {
            api.get('contact.json')
                .then((response) => {
                    this.contactInfo = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        saveDetails() {
            this.$refs.form.validate();
        },
    },
};
</script>
